export const MAX_TEMP = 100000; // Big number for the last temp range max

interface ITempRange {
  max: number;
  min: number;
}

interface IColourTemp {
  [key: string]: string;
}

export const colorTemps: IColourTemp = {
  '-14': 'rgb(76, 0, 30)',
  '-12': 'rgb(49, 0, 129)',
  '-10': 'rgb(1, 0, 132)',
  '-8': 'rgb(2, 44, 183)',
  '-6': 'rgb(6, 0, 255)',
  '-4': 'rgb(2, 122, 255)',
  '-2': 'rgb(0, 189, 255)',
  '0': 'rgb(0, 218, 138)',
  '2': 'rgb(51, 175, 14)',
  '4': 'rgb(32, 171, 30)',
  '6': 'rgb(27, 201, 20)',
  '8': 'rgb(0, 255, 13)',
  '10': 'rgb(72, 255, 3)',
  '12': 'rgb(157, 255, 5)',
  '14': 'rgb(255, 255, 7)',
  '16': 'rgb(255, 205, 5)',
  '18': 'rgb(255, 154, 4)',
  '20': 'rgb(255, 101, 2)',
  '22': 'rgb(255, 84, 0)',
  '24': 'rgb(255, 3, 2)',
  '26': 'rgb(255, 1, 127)',
  '28': 'rgb(255, 21, 145)',
  '30': 'rgb(255, 91, 178)',
  '32': 'rgb(255, 133, 195)',
  '34': 'rgb(255, 174, 216)',
  '36': 'rgb(255, 215, 236)',
  '38': 'rgb(255, 240, 248)',
};

/*
 * We generate ranges based on the temps above.
 * This way we avoid sorting the ranges for each marker rendered.
 * We keep the keys sorted in case a temp doesn't match any range,
 * we return the lowest one by default.
 * What's below returns an array of { max: number, min: number }
 */
const rangesMinsSorted = Object.keys(colorTemps).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
const tempRanges = rangesMinsSorted.reduce(
  (newTempRanges: ITempRange[], temp: string, index: number, sortedTempRanges: string[]) => {
    const max = sortedTempRanges.length - 1 > index ? parseInt(sortedTempRanges[index + 1], 10) : MAX_TEMP;

    newTempRanges.push({
      max,
      min: parseInt(temp, 10),
    });

    return newTempRanges;
  },
  [],
);

/*
 * Returns the colour that corresponds to the temp value as per the ranges above.
 */
export const getBackgroundForTemp = (temp: number): string => {
  const tempRange = tempRanges.find((range: ITempRange) => temp >= range.min && temp < range.max);

  if (!tempRange) {
    return colorTemps[rangesMinsSorted[0]];
  }

  return colorTemps[tempRange.min];
};
